import React, {useState} from 'react';
import { connect } from 'react-redux';
import {
    getAgentId,
    getIsFormValidating,
    getIsLoadingMobileCheck, getMobile,
    getreactivationParam,
    getreactivationStatus, mobileErrorCode,
    mobileMessage,
} from "../../selectors";
import {
    PAGE_SHOP,
    PARAM_MOBILE,
} from "../../constants";
import {
    getUserAndInactiveInfo,
    openDormantClientPopupAction,
    resendActivationLink, setMobile, setModalOpenAction,
    setReactivationData, setSuccessfulActivation,
    setTelephoneValidationData,
} from "../../reducers";
import {showLoader} from "../../utils";

const stateToProps = state => ({
    mobileMessage: mobileMessage(state),
    isLoadingMobileCheck: getIsLoadingMobileCheck(state),
    agentId: getAgentId(state),
    isFormValidating: getIsFormValidating(state),
    reactivationStatus: getreactivationStatus(state),
    reactivationParam: getreactivationParam(state),
    mobileErrorCode: mobileErrorCode(state),
    mobile: getMobile(state),
});

const actionsToProps = dispatch => ({
    setTelephoneValidationData: payload => dispatch(setTelephoneValidationData(payload)),
    getUserAndInactiveInfo: payload => dispatch(getUserAndInactiveInfo(payload)),
    setReactivationData: payload => dispatch(setReactivationData(payload)),
    setSuccessfulActivation: payload => dispatch(setSuccessfulActivation(payload)),
    resendActivationLink: payload => dispatch(resendActivationLink(payload)),
    setMobile: payload => dispatch(setMobile(payload)),
    setModalOpen: payload => dispatch(setModalOpenAction(payload)),
    openDormantClientPopup: payload => dispatch(openDormantClientPopupAction(payload)),
});

const MobilePhone = props => {
    const [telephone, setTelephone] = useState('');
    const showSuccess = props.reactivationStatus === 'success' && props.reactivationParam === PARAM_MOBILE && props.mobileMessage === 'success';

    const mobileErrorClass = props.mobileMessage === '' ? 'mobile' : 'error';

    const onChangeMobile = e => {
        const phone = e.target.value.trim();
        if (!phone.startsWith('0') && phone.length <= 10) {
            setTelephone(phone);
            props.setMobile(phone);
            reactivationReset(PARAM_MOBILE);

            if (phone.length === 0) {
                props.setTelephoneValidationData({ mobileMessage: '' });
            } else if (phone.length === 10 && props.agentId != null) {
                props.getUserAndInactiveInfo({ mobile: phone, agentId: props.agentId});
            }
        }
    }

    const reactivationReset = (paramName) => {
        if (paramName === props.reactivationParam) {
            props.setReactivationData({
                message: '',
                paramName: '',
                status: '',
                code: '',
            });
        }
    };

    const mobileErrorMessage = () => {
        let returnMessage = (
            <p className="callout p10 txt-l error"
               dangerouslySetInnerHTML={(() => ({ __html: `${props.mobileMessage} ` }))()}
            />
        );

        if (props.mobileErrorCode === -19735) {
            const text = props.mobileMessage.split('here');
            returnMessage = (
                <p className="callout p10 txt-l error">
                    {text[0]}
                    <span className="callout--link-clr" onClick={() => requestActivation()}>here</span>
                    {text[1]}
                </p>
            );
        } else if (props.mobileErrorCode === -21732) {
            if (props.pathname.startsWith(PAGE_SHOP)) {
                returnMessage = (
                    <p className="callout p10 txt-l error">
                        This mobile number is already registered with an existing account.
                        Please <span style={{color: '#cf1f1f', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => updateModal(true)}>click here</span> to recover and verify the number.
                    </p>
                );
            } else {
                // Used for registration with promocode page
                returnMessage = (
                    <p className="callout p10 txt-l error">
                        The mobile number is already assigned to an existing Bet9ja account.
                    </p>
                );
            }
        } else if (props.mobileErrorCode === -21738) {
            // Mobile is associated to a user that can be deleted
            if (props.pathname.startsWith(PAGE_SHOP)) {
                returnMessage = (
                    <p className="callout p10 txt-l error">
                        The mobile number is already assigned to an existing Bet9ja account.
                        Please <span style={{color: '#cf1f1f', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => updateModal(true)}>click here</span> to register the number again.
                    </p>
                );
            } else {
                // Used for registration with promocode page
                returnMessage = (
                    <p className="callout p10 txt-l error">
                        The mobile number is already assigned to an existing Bet9ja account.
                    </p>
                );
            }
        }

        if (props.reactivationCode < 0) {
            return (
                <React.Fragment>
                    <p className="callout p10 txt-l error"
                       dangerouslySetInnerHTML={(() => ({ __html: `${props.reactivationMessage} ` }))()}
                    />
                    {returnMessage}
                </React.Fragment>
            );
        }
        return returnMessage;
    };

    const requestActivation = () => {
        props.setSuccessfulActivation({ paramName: PARAM_MOBILE });
        props.resendActivationLink({
            paramName: PARAM_MOBILE,
            paramValue: props.mobile,
        });
    };

    const updateModal = open => {
        if (props.mobileErrorCode === -21738) {
            props.openDormantClientPopup();
        } else {
            props.setModalOpen(open);
        }
    }

    return (
        <div className={`form-row mobile ${props.mobileMessage === 'success' ? ' success' : `${mobileErrorClass}`}`}>
            <label className="form-label" htmlFor="mobile">
                {props.isLoadingMobileCheck && showLoader()}
                Mobile <span className="asterisk">*</span>
            </label>

            <input type="tel" className="form-input"
                   id="mobile" value={telephone} onChange={onChangeMobile} disabled={props.isFormValidating}/>

            <span className="form-input__mobile txt-c">
                +234
            </span>

            {props.mobileMessage ? mobileErrorMessage() : null}
            {showSuccess ?
                (<p className="callout callout--success p10 txt-l"
                    dangerouslySetInnerHTML={(() => ({ __html: `${props.reactivationMessage} ` }))()}/>)
                : null
            }

            <i className="form-status" />

            {(!props.mobileMessage || props.mobileMessage === 'success') &&
                <div className="tooltip">
                    NOTE: We recommend to disable DND to receive our great offers
                </div>
            }
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(MobilePhone);
